import React, { useMemo } from 'react';
import { Image, ImageStyle, StyleProp, StyleSheet, Text } from 'react-native';
import { getContrastYIQ } from '@oolio-group/design-common';
import { useTheme } from '../../hooks/useTheme';
import { ThemeColors } from '../../common/theme-colors';
import theme from '../../common/theme';

interface Props {
  logoUri?: string;
  name?: string;
  backgroundColor?: string;
  logoStyle?: StyleProp<ImageStyle>;
}

const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    name: {
      fontSize: 38,
      lineHeight: 46,
      paddingHorizontal: 40,
      textAlign: 'center',
      color: colors.text,
      fontFamily: theme.fonts.bold,
    },
  });

export const BrandMark: React.FC<Props> = ({
  logoUri,
  name,
  backgroundColor,
  logoStyle,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);

  if (logoUri) {
    return (
      <Image
        source={{ uri: logoUri }}
        style={logoStyle}
        resizeMode="contain"
        testID="brand-logo"
      />
    );
  }

  if (!name) return null;

  return (
    <Text
      testID="store-name"
      numberOfLines={2}
      style={[
        styles.name,
        // The brand colour is operator-supplied, so derive the text colour from
        // it. Without one the panel uses a theme surface, where colors.text
        // already contrasts.
        backgroundColor ? { color: getContrastYIQ(backgroundColor) } : null,
      ]}
    >
      {name}
    </Text>
  );
};
